// extracted by mini-css-extract-plugin
export default {"imageBlock":"ColorBlock_imageBlock__MA+4J","image":"ColorBlock_image__9s6dW","children":"ColorBlock_children__pstKx"};